/** @format */
import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { ROLES } from 'src/constants';

type AppRole = (typeof ROLES)[keyof typeof ROLES];

interface RoleGuardProps {
  children?: ReactNode;
  role?: AppRole;
}

const RoleGuard = ({ children, role }: RoleGuardProps) => {
  const { user } = useAuth();

  const hasAdminRole = Boolean(user?.isAdmin);
  const hasContentEditorRole = Boolean(user?.isEditor || hasAdminRole);

  if (role === ROLES.ADMIN && !hasAdminRole) return <Navigate to="/404" replace />;
  if (role === ROLES.CONTENT_EDITOR && !hasContentEditorRole) return <Navigate to="/404" replace />;
  if (!hasAdminRole && !hasContentEditorRole) return <Navigate to="/404" replace />;

  return <>{children}</>;
};

export default RoleGuard;
